// extracted by mini-css-extract-plugin
export default {"Shadow":"style_Shadow__ELZ-o"};